import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { signupSchema } from "../../validations/emailPassword";
import { Input } from "../../Input";
import { Button } from "../../../Buttons/Button";
import { useAuthContext } from "../../../../context/authContext";
import { CLEAR_AUTH_ERROR } from "../../../../reducers/types";

export function SignupForm({ onSubmit, isLoading }) {
  const { dispatch } = useAuthContext();

  const {
    handleSubmit,
    control,
    reset,
  } = useForm({
    resolver: yupResolver(signupSchema),
  });

  useEffect(() => {
    return () => {
      dispatch({ type: CLEAR_AUTH_ERROR });
      reset();
    };
  }, [dispatch, reset]);

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="grid grid-cols-1 gap-y-4 sm:grid-cols-1">
      <div className="sm:col-span-2">
        <Input name="name" label="Full Name" control={control} inputSize="xl" />
      </div>
      <div className="sm:col-span-2">
        <Input name="email" label="Email" control={control} inputSize="xl" />
      </div>
      <div className="sm:col-span-2">
        <Input
          name="password"
          label="Password"
          control={control}
          inputSize="xl"
          type="password"
        />
      </div>
      <div className="mt-4">
        <Button
          text="Create Account"
          type="submit"
          isLoading={isLoading}
          className="w-full flex justify-center min-h-[40px]"
          shape="default"
        />
      </div>
    </form>
  );
}